module.exports = __webpack_public_path__ + "assets/img/or-icon.1aad9e92.png";